<template>
	<div class="sort-by-control">
		<v-text-field v-if="search" :model-value="searchText" @update:model-value="emit('update:searchText', $event)" :label="searchLabel || t('Search')" prepend-inner-icon="search" variant="outlined" density="compact" clearable hide-details class="sort-by-control__search" :style="{ width: !select ? 'unset' : '100%' }" />
		<div class="sort-by-control__row">
			<SelectControl v-if="select" class="sort-by-control__select" :label="selectLabel || t('SortBy')" :items="items" :sort-items="false" :clearable="false" :model-value="sortBy" @update:model-value="emit('update:sortBy', $event)" />
			<v-btn icon variant="text" size="small" color="primary" @click="toggleSortOrder">
				<v-icon>{{ sortOrder === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</v-icon>
			</v-btn>
		</div>
	</div>
</template>

<script setup>
import { useTranslator } from '@/composables/useTranslator';
import SelectControl from '@/components/controls/SelectControl.vue';

const t = useTranslator();

const props = defineProps({
	items: { type: Array, default: () => [] },

	sortBy: { type: [String, Number, null], default: null },
	sortOrder: { type: String, default: 'asc' },
	selectLabel: { type: String, default: '' },
	select: { type: Boolean, default: true },
	search: { type: Boolean, default: false },
	searchText: { type: String, default: '' },
	searchLabel: { type: String, default: '' },
});
const emit = defineEmits(['update:sortBy', 'update:sortOrder', 'update:searchText']);

function toggleSortOrder() {
	emit('update:sortOrder', props.sortOrder === 'asc' ? 'desc' : 'asc');
}
</script>

<style lang="scss">
.sort-by-control {
	display: flex;
	flex-direction: column;
	gap: 8px;

	&__search {
		flex: 1 1 260px;
		max-width: 360px;
	}

	&__row {
		display: flex;
		align-items: flex-start;
		gap: 8px;
	}

	&__select {
		flex: 1 1 auto;
		max-width: 100%;
	}
}
</style>
